import { withFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { defaultError, defaultSuccess, goToTop } from "../../libs/utils";
import { updatePassword } from "../../services/api/auth";
import "../../styles/vendor/react-checkbox-tree.css";
import BasicInput from "./fields/BasicInput";
import {store} from "../../redux/store";
import {SYSTEM_ACTIONS} from "../../redux/system/actions";
import {USER_ACTIONS} from "../../redux/auth/actions";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    //props.loading = false;
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    resetForm: PropTypes.func,
    loading: PropTypes.bool
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isSubmitting && !nextProps.isSubmitting) {
      this.props.resetForm();
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <form
        className="m-form m-form--fit m-form--label-align-right"
        onSubmit={handleSubmit}
      >
        <div className="form-group m-form__group row">
          <div className="col-10 ml-auto">
            <h3 className="m-form__section">Change Password</h3>
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Old Password
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="password"
              name="old_password"
              noFormGroup
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            New Password
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="password"
              name="new_password"
              noFormGroup
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Repeat
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="password"
              name="repeat_password"
              noFormGroup
            />
          </div>
        </div>

        <div className="m-form__actions">
          <div className="row">
            <div className="col-2" />
            <div className="col-7">
              <button
                key="1"
                className={
                  "btn btn-brand m-btn m-btn--custom" +
                  (this.props.loading
                    ? " m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={this.props.loading}
              >
                Update
              </button>
              &nbsp;&nbsp;
              <button
                type="reset"
                className="btn btn-secondary m-btn m-btn--custom"
              >
                Cancel
              </button>
            </div>
          </div>
          <div class="row">
            <div className="col-2" />
                <div className="col-7">
                  <span className="m-form__help">
                    You will need to login again after changing your password.
                  </span>
              </div>
          </div>
        </div>
      </form>
    );
  }
}

const ChangePasswordForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      old_password: "",
      new_password: "",
      repeat_password: ""
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.old_password || values.old_password === "") {
      errors.old_password = "required";
    }

    if (!values.new_password || values.new_password === "") {
      errors.new_password = "required";
    }

    if (values.new_password.length < 6) {
      errors.new_password = "password must be at least 6 characters.";
    }

    if (!values.repeat_password || values.repeat_password === "") {
      errors.repeat_password = "required";
    }

    if (values.new_password !== values.repeat_password) {
      errors.repeat_password = "passwords do not match";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    updatePassword(props.user.id, {
      currentPassword: values.old_password,
      newPassword: values.new_password
    })
      .then(response => {
        defaultSuccess("Password Changed! You will need to login again.");
        setTimeout(() => {
          store.dispatch(USER_ACTIONS.logoutRequest());
          window.location.reload();
        }, 5000);
        goToTop();
      })
      .catch(e => {
        defaultError(e.response.data.message)
        goToTop();
      });
  }
})(InnerForm);

export default ChangePasswordForm;
